import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type UserRole =
  | "SUPER_ADMIN"
  | "ADMIN"
  | "LAB_ADMIN"
  | "LAB_USER"
  | "APP_USER"
  | "CLIENT"
  | "CLIENT_EMPLOYEE";

export interface AuthUser {
  id: number;
  emailAddress: string;
  role: UserRole;
  clientId?: number;
  clientName?: string;
  firstName?: string;
  lastName?: string;
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: AuthUser; token: string }>
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;

      // persist login (optional)
      localStorage.setItem("auth", JSON.stringify(action.payload));
    },

    loadStoredSession: (state) => {
      const saved = localStorage.getItem("auth");
      if (saved) {
        const parsed = JSON.parse(saved);
        state.user = parsed.user;
        state.token = parsed.token;
        state.isAuthenticated = true;
      }
    },

    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("auth");
    },
  },
});

export const { setCredentials, logout, loadStoredSession } = authSlice.actions;

export default authSlice.reducer;
